export default class DisplayAddress {
    constructor(address)
    {
        this.address = address;
    }

    get()
    {
        if ( ! this.address || ( this.address.city == null && this.address.postal_code == null ) ) {
            return '';
        }

        if ( ! this.address.street_name ) {
            if ( ! this.address.postal_code ) {
                return this.address.city;
            }

            return `${this.address.postal_code} ${this.address.city}`;   
        }

        if ( this.address.street_name && ! this.address.street_number ) {
            return `${this.address.street_name}, ${this.address.postal_code} ${this.address.city}`;   
        }

        return `${this.address.street_name} ${this.address.street_number}, ${this.address.postal_code} ${this.address.city}`;
    }
}